var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppStatusBarFailedDefault = function SvgAppStatusBarFailedDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 13,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 12,
    fill: "#EAECF6",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 150,
    y: 0.225,
    fill: "#D05353",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.282 3.507a.96.96 0 0 0 0 1.359l1.359 1.36-1.359 1.358a.96.96 0 1 0 1.359 1.36L156 7.584l1.359 1.36a.96.96 0 1 0 1.359-1.36l-1.359-1.359 1.359-1.36a.96.96 0 1 0-1.359-1.358L156 4.866l-1.359-1.36a.96.96 0 0 0-1.359 0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#604DBC",
    rx: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 2.838,
    y: 3,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 302,
    y: 3.45,
    stroke: "#C4C9D9",
    strokeWidth: 2,
    rx: 3
  })));
};
export { SvgAppStatusBarFailedDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzExIiBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgMzExIDEzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMzExIiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iI0VBRUNGNiIvPgo8cmVjdCB4PSIxNTAiIHk9IjAuMjI1MDk4IiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjRDA1MzUzIi8+CjxwYXRoIGQ9Ik0xNTMuMjgyIDMuNTA2NjFDMTUyLjkwNiAzLjg4MTk2IDE1Mi45MDYgNC40OTA1IDE1My4yODIgNC44NjU4NkwxNTQuNjQxIDYuMjI1MUwxNTMuMjgyIDcuNTg0MzRDMTUyLjkwNiA3Ljk1OTY5IDE1Mi45MDYgOC41NjgyMiAxNTMuMjgyIDguOTQzNThDMTUzLjY1NyA5LjMxODk0IDE1NC4yNjUgOS4zMTg5MyAxNTQuNjQxIDguOTQzNThMMTU2IDcuNTg0MzRMMTU3LjM1OSA4Ljk0MzU4QzE1Ny43MzUgOS4zMTg5NCAxNTguMzQzIDkuMzE4OTMgMTU4LjcxOCA4Ljk0MzU4QzE1OS4wOTQgOC41NjgyMyAxNTkuMDk0IDcuOTU5NyAxNTguNzE4IDcuNTg0MzRMMTU3LjM1OSA2LjIyNTFMMTU4LjcxOCA0Ljg2NTg2QzE1OS4wOTQgNC40OTA1MSAxNTkuMDk0IDMuODgxOTcgMTU4LjcxOCAzLjUwNjYxQzE1OC4zNDMgMy4xMzEyNSAxNTcuNzM1IDMuMTMxMjYgMTU3LjM1OSAzLjUwNjYxTDE1NiA0Ljg2NTg2TDE1NC42NDEgMy41MDY2MUMxNTQuMjY1IDMuMTMxMjUgMTUzLjY1NyAzLjEzMTI2IDE1My4yODIgMy41MDY2MVoiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiM2MDREQkMiLz4KPHJlY3QgeD0iMi44Mzc4OSIgeT0iMyIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIzMDIiIHk9IjMuNDUwMiIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0iI0M0QzlEOSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";